<div class="container-fluid" *ngIf="checkDataExists">
    <div class="row ">
        <fieldset class="border rounded-3 p-1 showCustomTable">
            <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_RISK_TAB.TITLE' | translate}}</legend>
            <div class="col-md-4 px-1">
                <div class="risk-herader">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{'REVIEW_SOL_RISK_TAB.AUTO_RISK_APPLIED' | translate}}</th>
                                <th>{{'REVIEW_SOL_RISK_TAB.DOLLARS' | translate}}</th>
                                <th>{{'REVIEW_SOL_RISK_TAB.TDC_PERCENT' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{'REVIEW_SOL_RISK_TAB.RISK' | translate}}</td>
                                <td>{{riskAppliedCost | multilingualCurrency }}</td>
                                <td>{{percentofTDC | decimalPrecision }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="checkDataExists" class="row px-1">
                <div class="col-md-6 m-0-10-0" *ngFor="let dataSource of groupedReviewList; let i = index">
                    <div class="mat-elevation-z8">
                        <div class="table-header">
                            <strong>{{ dataSource[0]?.levelDescription }}</strong>
                        </div>
                        <table mat-table [dataSource]="dataSource" class="mat-table custom-table table-bordered">
                            <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                                <th mat-header-cell *matHeaderCellDef class="custom-header"
                                    [style.width]="column.colWidth"> {{ column.header | translate }} </th>
                                <td mat-cell *matCellDef="let element" class="custom-cell"
                                    [class.right-align]="column.isRightAlign"> {{
                                    element[column.field] }} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsRiskWise"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsRiskWise;"></tr>
                        </table>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</div>
<div class="container-fluid customizeText" *ngIf="!checkDataExists">
    {{'REVIEW_SOL_RISK_TAB.RISK_DATA_NOT_FOUND' | translate}}
</div>